import { Component, OnInit, Input } from '@angular/core';
import { Image } from '../services/kla.data.models';
import { KlaHttpService } from '../services/kla.http.service';
import { CommonModule } from '@angular/common';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';
import { InspectImageDirective } from 'app/shared/directives/image-inspect.directive';

@Component({
  selector: 'kla-image-object',
  templateUrl: './image-object.component.html',
  styleUrls: ['./image-object.component.scss'],
  standalone: true,
  imports: [ CommonModule, DynamicContentComponent, InspectImageDirective ]
})
export class ImageObjectComponent implements OnInit {

  @Input() imageObject: Image;
  @Input() imageClass: string;
  @Input() captionColor = '#474747';
  @Input() imageHeight: string | number;
  @Input() imageWidth: string | number;

  imagePath: string;

  constructor(
    private httpService: KlaHttpService
  ) { }

  setFigureStyles() {
    return {
      'max-width': '500px',
      // 'max-height': `${this.imageHeight}`
    };
  }
  setImageStyles() {
    let styles = {
      'max-width': '100%',
      'max-height': this.imageHeight,
      'width': 'auto'
    }
    return styles;
  }

  setImageContainerStyles() {
    return {
      'width': this.imageWidth,
      'text-align': 'center'
    }
  }

  ngOnInit() {
    if (!this.imageObject) { return; }
    if ((this.imageObject.cropConfig || this.imageObject.crop_config) && (this.imageObject.width || this.imageObject.height)) {
      this.imagePath = this.httpService.getCroppedImagePath(this.imageObject);
    } else {
      this.imagePath = this.httpService.getImagePath(this.imageObject.id, this.imageObject.width);
    }
  }

}
